import script from "./AtividadeView.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadeView.vue?vue&type=script&setup=true&lang=js"

import "./AtividadeView.vue?vue&type=style&index=0&id=6c9df52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9df52e"]])

export default __exports__